import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { View } from "react-native"
import { Divider, TouchableRipple } from "react-native-paper"

export const CustomTab = (props) => {
    const { title, currentScreen, onPress, value } = props
    const active = currentScreen === value
    const activeColor = active ? baseColors.green.primary : baseColors.black
    const activeBgColor = active ? baseColors.green.primary : baseColors.grey

    return (
        <View style={{ flex: 1 }}>
            <TouchableRipple onPress={() => onPress?.()} rippleColor="rgba(0, 0, 0, .32)">
                <>
                    <Spacer height={8} />
                    <OpenSansText fontSize={16} color={activeColor} textAlign="center">
                        {title}
                    </OpenSansText>

                    <Spacer height={8} />

                    <Divider
                        style={{
                            height: 2,
                            backgroundColor: activeBgColor
                        }}
                    />
                </>
            </TouchableRipple>
        </View>
    )
}
